import { set } from "vue";

const UPDATE_PROPOSED_DISCUSSION = (state, { field, value }) => {
  set(state.proposedDiscussion, field, value);
};

export default UPDATE_PROPOSED_DISCUSSION;
